function accordionShowAndCollapse() {
  $('.format-all-about h3, .format-all-about .section-name-question').click(function() {
    if(!$(this).next().hasClass('show-text')) {
      $(this).next().addClass('show-text');
      $(this).addClass('opened');
    } else {
      $(this).next().removeClass('show-text');
      $(this).removeClass('opened');
    }
  });
}

function articleColorChange() {
  if (shopName === 'jam' || shopName === 'mee') {
    $('.important-info-h').addClass('visual-important-info-h-jam-mee');
  }
}

// add button for display extra content in articles
function toggleContentArticles() {
  $(document).on('click', '.toggle-button-articles', function () {
    // currently clicked element
    var currentToggleButton = $(this);
    var extraContent = currentToggleButton.prev('.extraContent');
    // toggle class hidden
    if (extraContent.hasClass('hidden')) {
      extraContent.removeClass('hidden');
      // change text to alternative from data-hide-text
      var newText = currentToggleButton.data('hide-text');
      if (newText) {
        currentToggleButton.text(newText);
      }
    } else {
      extraContent.addClass('hidden');
      // restore the original text from data-show-text
      var originalText = currentToggleButton.data('show-text');
      if (originalText) {
        currentToggleButton.text(originalText);
      }
    }
  });
}
